import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Constants } from './constants';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  weburl = Constants.webURL;
  private renderer: Renderer2;

  constructor(private title: Title, private meta: Meta, private router: Router,@Inject(DOCUMENT) private doc: Document,private rendererFactory: RendererFactory2 ) 
  {    this.renderer = this.rendererFactory.createRenderer(null, null);
  }
  updateTitle(title: string) {
    this.title.setTitle(title);
  }
  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc });
  }

  updateKeywords(keywords: string){
    this.meta.updateTag({ name: 'keywords', content: keywords });
  }
  addSwiftTypeData(type: string){
    this.meta.addTag({ class: 'swiftype', name: 'futekclass', 'data-type': 'string', content: type });
  }
  addSchemaScript() {
    const scriptContent = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://mitresource.com/testcasesforecommerce/"
      },
      "headline": "7 important Test cases for your e-commerce website success",
      "description": "The e-commerce sector has experienced remarkable growth, drawing businesses of all sizes into the digital marketplace.",
      "image": "https://mitresource.com/assets/images/testcase-images/testcases-image.webp",
      "author": {
        "@type": "Organization",
        "name": "Maganti IT Resources",
        "url": "https://mitresource.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Maganti IT",
        "logo": {
          "@type": "ImageObject",
          "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
        }
      },
      "datePublished": "2023-11-15"
    };

    const scriptTag = this.renderer.createElement('script');
    this.renderer.setAttribute(scriptTag, 'type', 'application/ld+json');
    this.renderer.setProperty(scriptTag, 'text', JSON.stringify(scriptContent));
    this.renderer.appendChild(document.head, scriptTag);
  }

  updateOgUrl(url: string) {
    this.meta.updateTag({ name: 'og:url', content: url })
  }
  createLinkForCanonicalURL() {
    const links = this.doc.querySelectorAll("link[rel='canonical']");
    if (links.length > 0 && links[0].parentNode) {
      links[0].parentNode.removeChild(links[0]);
    }
  
    const link: HTMLLinkElement = this.doc.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.doc.head.appendChild(link);
    link.setAttribute('href', this.weburl + this.router.url);
  }



}

